<!--
    file type .....: HTML file: security.component.html
    Created By ....: ianday
    Date ..........: 7/9/25 
-->
<div class="security-container">
   <div id="treeCtrl" class="tree-control">
       <div id="secsearchbarid" class="security-search-bar">
            <div style="width:25%;text-align:left;font-weight:bold">
                Security Assignments
            </div>

            <div style="width:50%">
               <span style="font-size: 9pt">Search: </span>

                <input id="txtFilter" #txtFilter
                       type="text"
                       matTooltip="Type to match data in all columns except date fields"
                       class="qs_filter-field security-search-input"
                       (keyup)="applyFilter($event.target.value)"
                       placeholder="<search>">

                <button mat-button matSuffix mat-icon-button
                        style="scale:80%"
                        matTooltip="Clear the filter" aria-label="Clear"
                        (click)="txtFilter.value = ''; applyFilter('')">
                    <mat-icon>close</mat-icon>
                </button>
           </div>
           <div class="pagination-section">
               <button  mat-button *ngIf="!expanded" (click)="expandAll()"
                        matTooltip="Click to expand the tree"
                        class="command-button expand-collapse-button">[ + ]</button>
               <button  mat-button *ngIf="expanded" (click)="collapseAll()"
                        matTooltip="Click to collapse the tree"
                        class="command-button expand-collapse-button">[ - ]</button>
           </div>
        </div>

       <p-treeTable #tt [value]="files" [columns]="cols"
           class="sec-tree"
           [scrollable]="true"
           [filterMode]="filterMode"
           [globalFilterFields]="['name', 'rightTypeLabel']"
           (onNodeSelect)="onNodeSelect($event)"
           (onNodeUnselect)="onNodeUnselect($event)"
           scrollHeight="345px"
           selectionMode="single"
           [metaKeySelection]="true"
           [(selection)]="selectedTarget">
            <ng-template pTemplate="header">
                <tr style="border-bottom: .5px solid #e1e1e1">
                    <th style="width: 550px">Target Element:</th>
                    <th>Access:</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body"
                let-rowNode let-rowData="rowData">
                <tr  [ttRow]="rowNode" [ttSelectableRow]="rowNode">
                    <td style="width: 550px;">
                        <div class="tree-toggle-container-override" >
                           <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        </div>

                        <div class="icon-and-name">
                         <mat-icon *ngIf=" rowData.elementType === 'Navigation'"
                                   matTooltip="Type: Navigation"
                                   class="icon-navigation">explore</mat-icon>

                            <mat-icon *ngIf=" rowData.elementType === 'Component'"
                                      matTooltip="Type: Component"
                                      class="icon-component">class</mat-icon>

                            <mat-icon *ngIf=" rowData.elementType === 'Field'"
                                      matTooltip="Type: Field"
                                      class="icon-field">input</mat-icon>
                            <mat-icon *ngIf=" rowData.elementType === 'Option'"
                                      matTooltip="Type: Option"
                                      class="icon-option">list</mat-icon>
                             <mat-icon *ngIf=" rowData.elementType === 'Control'"
                                      matTooltip="Type: Control"
                                      class="icon-control">open_in_browser</mat-icon>

                            <span>{{rowData.name}}</span>
                            <span *ngIf="rowData.activeStatus === 'InActive'"
                                  style="font-size: 8pt; font-style: italic">
                                (InActive)</span>
                        </div>
                    </td>

                    <div style="display: flex; height:100%;padding-top:1px; ">
                        <dw-dropdown #ddaccess
                                 *ngIf="selectedTarget?.data?.id == rowData.id"
                                 [id]="'accessDropListId'"
                                 [fontSize]="'9pt'"
                                 [useStyleOverride]="true"
                                 [ngClass]="'access-dropdown'"
                                 [useStatusOptions]="fetchAccessOptions(rowData.optionShow,
                                    rowData.optionExecute, rowData.optionReadOnly, rowData.optionReadWrite)"
                                 [placeHolder]="'No Access'"
                                 [selectedItem]="rowData.rightType"
                                 [controlWidth]="'120px'"
                                 (itemSelected)="rowData.rightType = $event;">
                        </dw-dropdown>

                        <span *ngIf="selectedTarget?.data?.id !== rowData.id"
                              style="padding-left: 3px;padding-top:3px;"
                              [ngStyle]="{'color': showAccessColor(rowData.rightType)}">
                              {{labelerDescription(rowData.rightType)}}
                        </span>
                    </div>
                  </tr>
            </ng-template>
        </p-treeTable>
    </div>

    <div id="detailDiv" class="detail-div" >

        <div class="top-third">
            <div class="component-name-style">
                <div class="component-label" style="width:100px;">Component:</div>
                <div class="short-data-values">{{valComponent }}</div>
                <div></div>
                <div class="component-label" style="padding-top:8px;">Description:</div>
            </div>
            <div style="display: table-cell; width:375px; height: 45px;">
                <div class="component-label">Active Status:</div>
                <div class="short-data-values">{{ valActiveStatus }}</div>
                <div></div>
                <div class="component-label" style="padding-top:8px;">Component Type:</div>
                <div class="short-data-values">{{ valType }}</div>
            </div>
        </div>

        <div class="mid-third">
            <div class="div-text-input" [innerHTML]="valDescription"></div>
        </div>
        <div class="bottom-third">
            <mat-checkbox [checked]="valUsedInMultipleAreas"
              [disableRipple]="true"
              (click)="$event.preventDefault()" style="max-width:450px;">
              This component is used in multiple areas
            </mat-checkbox>
        </div>
    </div>

    <div class="error-line" [hidden]='!strErr.length'
         style="margin-left: 4px; text-align:left">{{ strErr }}
    </div>

    <div class="save-close-strip">
        <button  class="command-button" *ngIf="isEditing"
                 (click)="submitRecord()" matTooltip="Submit the selected record"
                 mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button class="command-button" *ngIf="isEditing"
                (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
